import { Component } from "react";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="py-20 text-center text-text-muted text-sm">
          Something went wrong. Please refresh.
        </div>
      );
    }

    return this.props.children;
  }
}